import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Nav from "../../components/Navbar/Nav";
import Footer from "../../components/Footer/Footer";

export default function PaymentStatus() {
  const [params] = useSearchParams();
  const merchantOrderId = params.get("merchantOrderId");

  const [status, setStatus] = useState("LOADING");
  const [error, setError] = useState("");

useEffect(() => {
  if (!merchantOrderId) {
    setError("Missing order reference.");
    return;
  }

  fetch(
    `https://xperio.onrender.com/api/phonepe/order-status?merchantOrderId=${merchantOrderId}`
  )
    .then((res) => res.json())
    .then((data) => {
      setStatus(data.state || "UNKNOWN");
    })
    .catch(() => {
      setError("Unable to verify payment status.");
    });
}, [merchantOrderId]);


  const renderContent = () => {
    if (error) {
      return <p style={{ color: "red" }}>{error}</p>;
    }

    if (status === "COMPLETED") {
      return (
        <>
          <h2>✅ Payment Successful</h2>
          <p>  Your payment went through successfully! The enrollment is complete.
  We have mailed you the Invoice. Please check your spam folder and if you haven't received it, contact us.</p>
        </>
      );
    }

    if (status === "FAILED") {
      return (
        <>
          <h2>❌ Payment Failed</h2>
          <p>Your payment could not be completed. Pls try again.</p>
        </>
      );
    }

    return (
      <>
        <h2>⏳ Payment Pending</h2>
        <p>Please wait or contact support if amount was deducted.</p>
      </>
    );
  };

  return (
    <>
      <Nav />
      <main style={{ padding: "3rem", textAlign: "center" }}>
        {renderContent()}
      </main>
      <Footer />
    </>
  );
}
